<div class="amm-container">
  <div class="amm-hero">
    <span class="amm-sparkle s1 material-icons">auto_awesome</span>
    <span class="amm-sparkle s2 material-icons">auto_awesome</span>
    <span class="amm-sparkle s3 material-icons">auto_awesome</span>
    <div class="amm-avatar-ring">
      <img [src]="managerPhoto" class="amm-avatar" [alt]="managerName" />
      <span class="amm-wave">👋</span>
    </div>
  </div>

  <div class="amm-name">{{ managerName }}</div>
  <div class="amm-role">Your Account Manager</div>
  <div class="amm-blurb">
    Here to help you get your properties live — reach out any time.
  </div>

  <div class="amm-actions">
    <button class="amm-action" (click)="email()">
      <span class="amm-action-icon material-icons">email</span>
      <span class="amm-action-label">Email</span>
    </button>
    <button class="amm-action" (click)="text()">
      <span class="amm-action-icon material-icons">chat_bubble</span>
      <span class="amm-action-label">Text</span>
    </button>
    <button class="amm-action" (click)="schedule()">
      <span class="amm-action-icon material-icons">event</span>
      <span class="amm-action-label">Schedule</span>
    </button>
  </div>

  <div class="amm-availability">
    <span class="amm-availability-dot"></span>
    Typically replies within an hour
  </div>
</div>
